export enum ArticleType {
  Announcement = 1,
  TrainingMaterial = 2,
}

export const ArticleTypeDisplayName: Record<ArticleType, string> = {
  [ArticleType.Announcement]: 'Announcement',
  [ArticleType.TrainingMaterial]: 'Training Material',
}
